import { tableSchema } from '@nozbe/watermelondb'

export const productSchema = tableSchema({
  name: 'product',
  columns: [
    { name: 'productId', type: 'string' },
    { name: 'productCode', type: 'string' },
    { name: 'description', type: 'string' },
    { name: 'active', type: 'boolean' },
    { name: 'commercialization', type: 'boolean' },
    { name: 'continuous', type: 'boolean' },
    { name: 'cultivate', type: 'boolean' },
    { name: 'digitalization', type: 'boolean' },
    { name: 'minReceiptDate', type: 'string' },
    { name: 'nfe', type: 'boolean' },
    { name: 'productGroupId', type: 'string' },
    { name: 'purchasing', type: 'boolean' },
    { name: 'scheduled', type: 'boolean' },
    { name: 'shortDescription', type: 'string' },
    { name: 'slug', type: 'string' },
    { name: 'barcodes', type: 'string' },
    { name: 'ean', type: 'string' },
    { name: 'extraAttributes', type: 'string' },
    { name: 'createdAt', type: 'string' },
    { name: 'updatedAt', type: 'string' }
  ]
})